import type { ApiError } from './errors/errors';

export type Invite = {
  email?: string;
  firstName: string;
  lastName: string;
  phoneNumber?: string;
};

export type RetrieveInviteResponse = {
  birthday: DateISOString;
  email: string;
  firstName: string;
  household: string;
  id: string;
  invitedBy: string;
  lastName: string;
  nickname?: string;
  phoneNumber?: string;
  priceId: string;
};

export type RetrieveReferralsResponse = {
  referredName: string;
  status: 'Accepted' | 'Pending' | 'Waitlist';
};

export type CreateInviteRequest = Invite & {
  id: string;
};

export type CreateInviteResponse = unknown;

export const INVITE_ERROR_DETAIL = {
  INVITE_ALREADY_ACCEPTED: 'Invite already accepted.',
  INVITE_EXPIRED: 'Invite is expired.',
} as const;

export type InviteAlreadyAcceptedError = ApiError<4042, typeof INVITE_ERROR_DETAIL.INVITE_ALREADY_ACCEPTED>;

export type InviteExpiredError = ApiError<4042, typeof INVITE_ERROR_DETAIL.INVITE_EXPIRED>;

export type RetrieveInviteError = ApiError<4041> | InviteAlreadyAcceptedError | InviteExpiredError;
